var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "inst-suggest" },
    [
      _c("el-autocomplete", {
        ref: "elAutocomplete",
        style: { height: _vm.height },
        attrs: {
          "popper-class": "my-autocomplete",
          clearable: "",
          maxlength: _vm.maxLength,
          size: _vm.size,
          "fetch-suggestions": _vm.querySearch,
          placeholder: _vm.placeholder,
          "trigger-on-focus": false
        },
        on: {
          select: _vm.handleSelect,
          input: _vm.handleInput,
          clear: _vm.handleClear,
          blur: _vm.handleBlur
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function(ref) {
              var item = ref.item
              return [
                _c("el-tooltip", { attrs: { placement: "right" } }, [
                  _c("div", { attrs: { slot: "content" }, slot: "content" }, [
                    _vm._v(_vm._s(item.title))
                  ]),
                  _c("div", { staticClass: "inst-suggest-title one-line" }, [
                    _vm._v(_vm._s(item.title))
                  ])
                ]),
                _c("el-tooltip", { attrs: { placement: "right" } }, [
                  _c("div", { attrs: { slot: "content" }, slot: "content" }, [
                    _vm._v(_vm._s(item.issueNum))
                  ]),
                  _c("div", { staticClass: "inst-suggest-num one-line" }, [
                    _vm._v(_vm._s(item.issueNum))
                  ])
                ])
              ]
            }
          }
        ]),
        model: {
          value: _vm.suggestValue,
          callback: function($$v) {
            _vm.suggestValue = $$v
          },
          expression: "suggestValue"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }